var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogged)?_c('div',{staticClass:"wrapper"},[_c('NavBar'),_c('Aside'),_c('slide-y-up-transition',{attrs:{"mode":"out-in","origin":"center top"}},[_c('router-view')],1),_c('LaravelEcho'),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }